/**
 * @param args {array|string[]|string} Variadic arguments of class names
 * @returns {string} Returns truthy filtered, string coerced concatenated list of arguments
 */
export const toClasses = (...args) => {

    const classNames = [];
    for (let i = 0; i < args.length; i++) {
        const arg = args[i];
        if (arg) {
            classNames.push(arg + '');
        }
    }

    return classNames.join(' ');
};
